import InfoBoxIcon from '../../../assets/img/icons/InfoBoxIcon';
import {cn} from '../../../lib/utils';
import {ReactNode} from 'react';

interface InfoBoxProps {
	text?: string;
	className?: string;
	children?: ReactNode;
}

export default function InfoBox({text, className, children}: InfoBoxProps){
	return (
		<div className={cn('relative flex items-center gap-2.5 bg-blue-light-2 py-3 px-4 border-l-4 border-blue-dark-2 text-sm text-blue-dark-2', className)}>
			<span className={'w-5 h-5'}>
				<InfoBoxIcon className={''}/>
			</span>
			<p>{text}</p>
			{children}
		</div>
	);
}
